// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"8ef4e278","243":"8ef4e278","385":"3867588d","411":"8ef4e278","665":"8ef4e278","715":"8ef4e278"}[chunkId] + ".chunk.css";
};